// Imports
import firebase from '../config/FirebaseConfig'
import AxiosConfig from '../foreplayServer/serverAxiosConfig'

// Setup
const db = firebase.firestore()

// Get All By User
const getAllCreatedByUser = async (teamId) => {
  const user = firebase.auth().currentUser

  if (!user) return []

  const snapshot = await db.collection('invitations')
    .where('teamId', '==', teamId)
    .where('status', '==', 'pending')
    .get()

  return snapshot.docs?.map(doc => {
    return {
      id: doc.id,
      ...doc.data() || []
    }
  })
}

const getUserInvitations = async () => {
  const user = firebase.auth().currentUser

  if (!user) return []

  const snapshot = await db.collection('invitations')
    .where('toEmail', '==', user.email.toLocaleLowerCase())
    .where('status', '==', 'pending')
    .get()

  return snapshot.docs?.map(doc => {
    return {
      id: doc.id,
      ...doc.data() || []
    }
  })
}

const remove = async (invitationId) => {
  return db.collection('invitations').doc(invitationId).delete()
}

const reject = async (invitationId) => {
  return db.collection('invitations').doc(invitationId).update({ status: 'rejected' })
}

const accept = async (invitationId) => {
  return db.collection('invitations').doc(invitationId).update({ status: 'accepted' })
}

const getById = async (invitationId) => {
  const user = firebase.auth().currentUser
  if (!user) return null

  const authToken = await user.getIdToken()

  const { data: response } = await AxiosConfig.get(`/fs/invitations/${invitationId}`, {
    headers: {
      Authorization: `Bearer ${authToken}`
    }
  })

  return response.data
}

const getAllPending = async () => {
  const user = firebase.auth().currentUser
  if (!user) return []

  const authToken = await user.getIdToken()

  const { data: response } = await AxiosConfig.get('/fs/invitations', {
    headers: {
      Authorization: `Bearer ${authToken}`
    }
  })

  return response.data
}

export default {
  accept,
  getAllCreatedByUser,
  getUserInvitations,
  getAllPending,
  reject,
  remove,
  getById
}
